module.exports = __webpack_public_path__ + "img/potencia_r_b_red.7a8fffcc.svg";